import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import Config from "config";
import { map } from "lodash";
import {
  Col,
  Row,
  Card,
  CardBody,
  Nav,
  NavItem,
  NavLink,
  CardTitle,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
} from "reactstrap";
import Spinners from "components/Common/Spinner";
import { ToastContainer } from "react-toastify";
import { useParams } from "react-router-dom";
import ModelCard from "components/Common/ModelCard";
import SectionCard from "components/Common/SectionCard";
import ImageCard from "components/Common/ImageCard";

import SouscriptionsCard from "components/Common/SouscriptionsCard";
import HmPaginated from "components/Common/hmPaginated";
import ImpressionsHmListModele from "components/Common/ImpressionsHmListModele";
import IdentificationCard from "./IdentificationCard";
import TableComponent from "./TableComponent";
const backUrl = Config.backOffice.url;
const DetailModel = ({
  Titre,
  loading,
  setLoading,
  modeleData,
  impressionsData,
  activeTab,
  handleAction,
  handleTabClick,
  CustomNavTabs,
  fetchData,
  id,
  api,
  signature,
  wait,

  // Function to fetch data
}) => {
  let linkState = { active: "" };

  if (activeTab == "details") {
    linkState.active = "details";
  } else if (activeTab == "contact") {
    linkState.active = "contact";
  } else {
    linkState.active = "details";
  }

  const [modal, setModal] = useState(false);

  const toggleModal = () => setModal(!modal);

  useEffect(() => {
    fetchData();
  }, [signature]);
  useEffect(() => {
    if (wait === 0) {
      setLoading(false);
      console.log("test finished");
    }
  }, [wait]);

  return (
    <React.Fragment>
      <div className="page-content" style={{ fontFamily: "sans-serif" }}>
        <div className="container-fluid">
          <Row>
            <Col lg="12">
              <Card>
                <CardBody className="border-bottom">
                  <div className="d-flex align-items-center">
                    <h5
                      className="mb-0 card-title flex-grow-1"
                      style={{ fontWeight: "bold", display: "flex" }}
                    >
                      <Link
                        to={`${backUrl}/${api}/`}
                        style={{
                          color: "#3c88c8",
                          textDecoration: "underline !important",
                        }}
                      >
                        {Titre}
                      </Link>
                      <i className="bx bx-caret-right"></i>{" "}
                      {!loading ? (
                        modeleData.sil
                      ) : (
                        <>
                          <span
                            className="placeholder col-3"
                            style={{ height: "1em" }}
                          ></span>
                        </>
                      )}
                    </h5>
                  </div>

                  <div className="d-flex justify-content-end">
                    <div className="d-flex align-items-end">
                      {modeleData?.can_edit ? (
                        <Link
                          to={`${backUrl}/${api}/${id}/edit`}
                          state={linkState}
                          className="btn btn-sm btn-info"
                        >
                          <i className="bx bx-edit-alt"></i>Modifier
                        </Link>
                      ) : null}
                      &nbsp; &nbsp;
                      {modeleData?.can_destroy ? (
                        <Link to="#!" className="btn btn-sm btn-danger">
                          <i className="bx bx-trash-alt"></i>Supprimer
                        </Link>
                      ) : null}
                    </div>
                  </div>
                </CardBody>
                {CustomNavTabs()}
                <CardBody>
                  {activeTab === "details" && (
                    <div>
                      {!loading ? (
                        <>
                          <Row>
                            <Col sm="6">
                              {modeleData?.detail_publipostage?.[
                                "Caractéristiques"
                              ] ? (
                                <ModelCard
                                  title="Caractéristiques"
                                  details={
                                    modeleData?.detail_publipostage?.[
                                      "Caractéristiques"
                                    ]
                                  }
                                />
                              ) : null}
                            </Col>
                            <Col sm="6">
                              <Row>
                                {modeleData?.detail_publipostage?.[
                                  "Filtres / Cumul"
                                ] ? (
                                  <SouscriptionsCard
                                    title="Filtres / Cumul"
                                    details={
                                      modeleData?.detail_publipostage?.[
                                        "Filtres / Cumul"
                                      ]
                                    }
                                  />
                                ) : null}
                              </Row>
                              <Row>
                                <SectionCard
                                  title="Contenu"
                                  details={
                                    modeleData?.detail_publipostage?.Contenu
                                  }
                                />
                                <SectionCard
                                  title="Commentaires"
                                  details={
                                    modeleData?.detail_publipostage
                                      ?.Commentaires
                                  }
                                />
                              </Row>
                            </Col>
                          </Row>

                          <Row>
                            {modeleData?.detail_publipostage?.[
                              "Présentation / sortie"
                            ] ? (
                              <Col sm="6">
                                <ModelCard
                                  title="Présentation / sortie"
                                  details={
                                    modeleData?.detail_publipostage?.[
                                      "Présentation / sortie"
                                    ]
                                  }
                                />
                              </Col>
                            ) : null}
                            {modeleData?.detail_publipostage?.[
                              "Champs d'impression"
                            ] ? (
                              <Col sm="6">
                                <IdentificationCard
                                  title="Champs d'impression"
                                  details={
                                    modeleData?.detail_publipostage?.[
                                      "Champs d'impression"
                                    ]
                                  }
                                />
                                <ImageCard
                                  title="Images"
                                  images={
                                    modeleData?.detail_publipostage?.["Images"]
                                  }
                                />
                              </Col>
                            ) : null}
                            {modeleData?.detail_publipostage?.[
                              "Signature électronique"
                            ]?.Signataires ? (
                              <Row>
                                <Col sm="12">
                                  <CardTitle
                                    tag="h5"
                                    style={{ paddingBottom: "10px" }}
                                  >
                                    Signature électronique{" "}
                                  </CardTitle>
                                  <TableComponent
                                    header={
                                      modeleData?.detail_publipostage?.[
                                        "Signature électronique"
                                      ]?.Signataires?.header
                                    }
                                    data={
                                      modeleData?.detail_publipostage?.[
                                        "Signature électronique"
                                      ]?.Signataires?.data
                                    }
                                  />
                                </Col>
                              </Row>
                            ) : null}
                          </Row>
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} />
                      )}
                    </div>
                  )}

                  {activeTab === "impressions" && (
                    <div className="table-responsive">
                      {!loading ? (
                        <>
                          <ImpressionsHmListModele
                            title={impressionsData}
                            data={impressionsData.data}
                            header={impressionsData.header}
                            itemsPerPage={10}
                          />
                        </>
                      ) : (
                        <Spinners setLoading={setLoading} setWait={wait} />
                      )}
                    </div>
                  )}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </div>
      </div>

      <ToastContainer />
    </React.Fragment>
  );
};

export default DetailModel;
